import { forwardRef, type Ref, type SVGProps } from "react";
const IconPublicTransitFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M5 4a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm3 4.5a.5.5 0 0 1 .5-.5h3.732a.5.5 0 0 1 .477.35l3.358 10.633q.006.019.026.02a.03.03 0 0 0 .027-.02l3.175-10.626a.5.5 0 0 1 .48-.357H23.5a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-2.058a.5.5 0 0 1-.5-.5V12.685a.024.024 0 0 0-.047-.007L17.37 23.653a.5.5 0 0 1-.476.347h-1.79a.5.5 0 0 1-.475-.346L11.105 12.79a.024.024 0 0 0-.047.007V23.5a.5.5 0 0 1-.5.5H8.5a.5.5 0 0 1-.5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPublicTransitFilledSVG);
ForwardRef.displayName = "IconPublicTransitFilled";
export { ForwardRef as IconPublicTransitFilled };
